import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static values = { position: Number, url: String }
  connect() {
    this.lastSaved = 0
    this.resume = () => {
      if (this.positionValue > 0 && this.positionValue < this.element.duration) this.element.currentTime = this.positionValue
    }
    this.save = () => {
      if (!Number.isFinite(this.element.currentTime)) return
      const now = Date.now()
      if (!this.element.paused && now - this.lastSaved < 10000) return
      this.lastSaved = now
      fetch(this.urlValue, { method: "PATCH", keepalive: true, headers: {
        "Content-Type": "application/json", "Accept": "application/json", "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      }, body: JSON.stringify({ media_position: this.element.currentTime }) }).catch(() => {})
    }
    this.element.addEventListener("loadedmetadata", this.resume)
    this.element.addEventListener("timeupdate", this.save)
    this.element.addEventListener("pause", this.save)
    if (this.element.readyState >= 1) this.resume()
  }
  disconnect() {
    this.save()
    this.element.removeEventListener("loadedmetadata", this.resume)
    this.element.removeEventListener("timeupdate", this.save)
    this.element.removeEventListener("pause", this.save)
  }
}
